import { DeleteRequest, GetExcelRequest, GetRequest, PatchRequest, PostRequest, PutRequest } from '../../service';

const ControllerName = "user"

export const ExportUsersExcel = (link) =>
    GetExcelRequest(link, ControllerName)


export const GetAllUsers = (link) =>
    GetRequest(ControllerName + link)

export const GetUserDetails = (userID) =>
    GetRequest(ControllerName + '/' + userID)


export const AddUser = (UserData) =>
    PostRequest(ControllerName, UserData)

export const UpdateUser = (Userid, UserData) =>
    PutRequest(ControllerName + "/" + Userid, UserData)

export const DeleteUser = (Userid) =>
    DeleteRequest(ControllerName + "/" + Userid)

export const Register = (UserData) =>
    PostRequest(ControllerName + "/register", UserData)


export const ChangePassword = (PasswordData) =>
    PatchRequest(ControllerName + "/change-password", PasswordData)

export const VerifyAccount = (code) =>
    PatchRequest(ControllerName + "/verify-account?code=" + code) // To Do


export const GetUserInfo = () =>
    GetRequest(`${ControllerName}/user-info`)



